import React from 'react';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const {t}=useTranslation()
    return (
        <div style={{textAlign:"center",padding:"50px"}}>
              <h1>{t("404_title")}</h1>
              <p>{t("404_message")}</p>

        </div>
    );
}

export default NotFound;
